import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';

const rootStyle = css`
  .ant-anchor-link-title:hover {
    color: ${colors['@primary-color']};
  }
`;

const anchorConfig: ConfigProviderProps['anchor'] = { classNames: { root: rootStyle } };

export default anchorConfig;
